import React, { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
const BASE_VISITS = 847;
export function AnnouncementBar() {
  const [visits, setVisits] = useState<number | null>(null);
  useEffect(() => {
    const stored = localStorage.getItem('sos-reflujo-visits');
    const current = stored ? parseInt(stored, 10) : BASE_VISITS;
    const next = current + 1;
    localStorage.setItem('sos-reflujo-visits', String(next));
    setVisits(next);
  }, []);
  return <div className="bg-gradient-to-r from-accent-dark via-accent to-accent-light bg-[length:400%_400%] animate-gradient-shift text-center py-2.5 px-5 text-sm font-bold text-primary tracking-wide flex items-center justify-center gap-4 flex-wrap" data-id="element-19">
      <span data-id="element-20">
        Protocolo SOS Reflujo 11 PM — Oferta especial por tiempo limitado
        &nbsp;|&nbsp; Garantía de 7 días sin preguntas
      </span>
      {visits !== null && <span className="inline-flex items-center gap-1.5 bg-primary/20 py-0.5 px-2.5 rounded-full text-xs font-extrabold" data-id="element-21">
          <Eye className="w-3.5 h-3.5" data-id="element-22" />
          {visits.toLocaleString()} visitas
        </span>}
    </div>;
}